import Settings from "./settings";
import Autocomplete from "./autocomplete";
import AddressValidation from "./address-validation";
import EmailValidation from "./email-validation";
import AbrLookupByBusinessName from "./abr-lookup-by-business-name";
import GravityForms from "./gravity-forms";

/**
 * Initialize address autocomplete for custom CSS class-based address field groups
 * Supports multiple groups with pattern: datatools-integration-group-{N}-address-line-1
 */
function initCustomAddressGroups() {
	// Find all .gfield wrapper divs with address-line-1 classes
	let addressLine1Wrappers = document.querySelectorAll('.gfield[class*="datatools-integration-group-"][class*="-address-line-1"]');

	addressLine1Wrappers.forEach((wrapper) => {
		// Extract group number from wrapper div class names
		let classNames = wrapper.className;
		let groupMatch = classNames.match(/datatools-integration-group-(\d+)-address-line-1/);

		if (!groupMatch) {
			return;
		}

		let groupNumber = groupMatch[1];

		// Find the actual input element within this wrapper
		let input = wrapper.querySelector('input');
		if (!input) {
			return;
		}

		// Find the container element (closest form or a common parent)
		let container = wrapper.closest('form') || wrapper.closest('.gform_wrapper') || document.body;

		// Create selector mappings for this group - target inputs within wrapper divs
		let selectors = {
			AddressLine1: `.gfield.datatools-integration-group-${groupNumber}-address-line-1 input`,
			AddressLine2: `.gfield.datatools-integration-group-${groupNumber}-address-line-2 input`,
			City: `.gfield.datatools-integration-group-${groupNumber}-suburb input`,
			State: [
				`.gfield.datatools-integration-group-${groupNumber}-state select`,
				`.gfield.datatools-integration-group-${groupNumber}-state input`
			],
			Postcode: `.gfield.datatools-integration-group-${groupNumber}-postcode input`
		};

		// Initialize autocomplete for this group
		let autocomplete = new Autocomplete(container, input, selectors, `group_${groupNumber}`);
		autocomplete.init();
	});
}

/**
 * Build the key the server side validator knows a native Gravity Forms address field by.
 *
 * Address inputs are named input_{formId}_{fieldId}_{inputId}, and the validator keys the field by
 * its Gravity Forms field ID.
 *
 * @param {HTMLElement} input The address line 1 input.
 * @returns {string|null}
 */
function getGfAddressFieldKey(input) {
	if (!input || !input.id) {
		return null;
	}

	let parts = input.id.split("_");

	return parts.length >= 4 ? `field_${parts[2]}` : null;
}

document.addEventListener("DOMContentLoaded", () => {

	// missing forEach on NodeList for IE11
	if (window.NodeList && !NodeList.prototype.forEach) {
		window.NodeList.prototype.forEach = Array.prototype.forEach;
	}

	if (Settings.isAddressAutocompletionEnabled()) {

		//Automatically attach address autocompletion to WooCoommerce address fields
		let addressTypes = [
			"billing",
			"shipping",
		];

		let wooAutocompletes = [];

		addressTypes.forEach((addressType) => {
			let container = document.querySelector(".woocommerce-" + addressType + "-fields__field-wrapper,.woocommerce-address-fields__field-wrapper");
			let input = document.querySelector("#" + addressType + "_address_1");

			let autocomplete = new Autocomplete(container, input, {
				AddressLine1: "#" + addressType + "_address_1",
				AddressLine2: "#" + addressType + "_address_2",
				City: "#" + addressType + "_city",
				State: "#" + addressType + "_state",
				Postcode: "#" + addressType + "_postcode"
			}, addressType);
			autocomplete.init();

			wooAutocompletes.push(autocomplete);
		});

		//WooCommerce replaces the state field with a new element when the country changes,
		//taking the edit listeners attached at init() with it
		jQuery(document.body).on('country_to_state_changed', () => {
			wooAutocompletes.forEach((autocomplete) => autocomplete.refreshValidationWatch());
		});

		//Automatically attach address autocompletion to custom CSS class-based address field groups
		initCustomAddressGroups();
	}

	if (Settings.isAddressValidationEnabled()) {

		//Render the confirmation checkbox for any address the server soft-rejected on this page load
		AddressValidation.renderConfirmations();

		//The WooCommerce classic checkout submits over AJAX and re-renders its notices in place
		jQuery(document.body).on('checkout_error', function() {
			AddressValidation.renderConfirmations();
		});
	}

	jQuery(document).on('gform_post_render', function() {

		if (Settings.isAddressAutocompletionEnabled()) {

			//Automatically attach address autocompletion to Gravity Forms address fields
			let addressContainers = document.querySelectorAll(".ginput_complex.ginput_container_address");

			addressContainers.forEach((container) => {
				let input = container.querySelector(".address_line_1 input");

				let autocomplete = new Autocomplete(container, input, {
					AddressLine1: ".address_line_1 input",
					AddressLine2: ".address_line_2 input",
					City: ".address_city input",
					State: [".address_state select", ".address_state input"],
					Postcode: ".address_zip input"
				}, getGfAddressFieldKey(input));
				autocomplete.init();
			});

			//Automatically attach address autocompletion to custom CSS class-based address field groups
			initCustomAddressGroups();
		}

		if (Settings.areAbrLookupsEnabled()) {
			let abrLookupByBusinessNameContainers = document.querySelectorAll(".js-abr-search-field--business-name");
			abrLookupByBusinessNameContainers.forEach((container) => {
				let input = container.querySelector('input');
				let inputNumber = GravityForms.getGfInputNumber(input);

				let abrAutocomplete = new AbrLookupByBusinessName(container, input, {
					BusinessName: ".js-abr-result-field--business-name.js-abr-result-link-field_" + inputNumber + " input",
					ABN: ".js-abr-result-field--abn.js-abr-result-link-field_" + inputNumber + " input",
					State: ".js-abr-result-field--state.js-abr-result-link-field_" + inputNumber + " input",
					Postcode: ".js-abr-result-field--postcode.js-abr-result-link-field_" + inputNumber + " input",
					Status: ".js-abr-result-field--status.js-abr-result-link-field_" + inputNumber + " input",
				});
				abrAutocomplete.init();
			});
		}

		if (Settings.isEmailValidationEnabled()) {
			EmailValidation.setupGfEmailValidation();
		}

		if (Settings.isAddressValidationEnabled()) {
			AddressValidation.renderConfirmations();
		}
	});

	/**
	 * Close any open address autocomplete dropdown when the popup's content area scrolls.
	 *
	 * jQuery UI positions the dropdown by calculating the input's page offset at open time.
	 * If the popup's inner content scrolls, the input moves but the dropdown stays put,
	 * causing them to drift apart. Closing on scroll avoids the mismatch.
	 *
	 * The dropdown is appended to the popup container (via the appendTo option in Autocomplete),
	 * so page/background scroll behind the fixed popup does not cause drift and is intentionally
	 * ignored — only scroll within the popup widget itself is handled.
	 */
	window.addEventListener('elementor/popup/show', (event) => {
		const modal = event?.detail?.instance?.getModal?.();
		if (!modal || modal._datatoolsScrollGuard) return;

		const $widget = modal.getElements('widget');
		if (!$widget?.length) return;

		const popupEl = $widget[0];

		// Skip popups that contain no address autocomplete fields.
		if (!popupEl.querySelector('.ginput_container_address, [class*="datatools-integration-group-"]')) return;

		modal._datatoolsScrollGuard = true;

		const closeAutocompletes = () => {
			jQuery(popupEl).find('.ui-autocomplete-input').autocomplete('close');
		};

		popupEl.addEventListener('scroll', closeAutocompletes, { passive: true, capture: true });
	});

});
